import { useQuery } from "@tanstack/react-query"
import { getBackofficeCompanyQuery } from "modules/backoffice/lib/companies/getBackofficeCompanyQuery"

export function useGetBackofficeCompanyQuery(
  ...args: Parameters<typeof getBackofficeCompanyQuery>
) {
  return useQuery(getBackofficeCompanyQuery(...args))
}
